import React from "react";
import { useFormikContext } from "formik";
import { CaseDataResponse } from "../../../types/CaseTypes";
import { useFieldResourceData } from "../../../hooks/CaseView/useFieldResourceData";
import SectionHeader from "./FieldResourceSection/Header";
import FieldResourceList from "./FieldResourceSection/FieldResourceList";
import EmptyFieldResourceState from "./FieldResourceSection/EmptyFieldResourceState";
import { StoreContext } from "../../../context/StoreContext";

const FieldResourceSection: React.FC = () => {
  const { values } = useFormikContext<CaseDataResponse>();
  const { fieldResourceList } = useFieldResourceData();

  const hasFieldResources =
    values.case_detail.case_details.field_resource_information.length > 0;

  return (
    <div>
      <SectionHeader />

      {hasFieldResources ? (
        <FieldResourceList
          fieldResources={
            values.case_detail.case_details.field_resource_information
          }
          fieldResourceList={fieldResourceList}
        />
      ) : (
        <EmptyFieldResourceState />
      )}
    </div>
  );
};

export default FieldResourceSection;
